import { Stack, Typography, useTheme } from '@mui/material';

export default function ShortcutIcon({ inputs }) {
    const theme = useTheme();

    return (
        <Stack
            direction="row"
            flexWrap="nowrap"
            sx={{
                fontSize: '12px',
                position: 'relative',
                fontWeight: 'bold',
                border: '1px solid',
                borderColor: 'common.lightgray',
                padding: '5px',
                borderRadius: '5px',
                height: 'auto',
                width: 'auto',
                margin: '10px',
                display: { xxs: 'none', sm: 'flex' }
            }}
        >
            {inputs.map((input, index) => {
                return (
                    <Typography key={index} sx={{ color: 'common.gray', fontSize: theme.typography.pxToRem(10), lineHeight: '1', whiteSpace: 'nowrap' }}>
                        {input} {index < inputs.length - 1 && '+ '}
                    </Typography>
                );
            })}
        </Stack>
    );
}
